(function () {
  window.addEventListener('click', (e) => {
    if (!e.target.matches("header, header *")) {
      document.querySelectorAll("header-animate").forEach((el) => {
        //set attribute true to other elements but not this
        el.dataset.action = "close";
      })
    }
  });
})();

function getFocusableElements(container) {
  if (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  if (elements) {
    var first = elements[0];
    var last = elements[elements.length - 1];
  }

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not(.tw-btn-filters)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
    this.querySelector('.close-header-drawer')?.firstElementChild.addEventListener('click', this.onCloseButtonClick.bind(this));
    this.querySelector('.close-header-drawer')?.firstElementChild.addEventListener('click', this.bodyOverflowHidden.bind(this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    //const utilityBar = document.querySelector('.utility-bar'); 
    const menuDrawer = document.querySelector('#menu-drawer');
    menuDrawer.style.height = "100vh";
    menuDrawer.style.top = "-32px";
    //utilityBar.style.display = "none";

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }
    else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }



  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details:not(.mobile-facets__details--no-close)').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
    //this.bodyOverflowHidden();
  }

  bodyOverflowHidden() {
    const bodyOverflow = document.querySelector('body');
    bodyOverflow.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);

    // const utilityBar = document.querySelector('.utility-bar');
    // utilityBar.style.display = "block";
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

//custom element to close menu drawer with another custom button (not summary)
class ButtonCloseDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      this.closest(".mobile-facets__disclosure").querySelector(".mobile-facets__close").click();
    })
  }
}

customElements.define('button-drawer-close', ButtonCloseDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');


    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalOpenerTabs extends ModalOpener {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      const dataTabId = this.dataset.tabSelected;
      const tabSelected = modal.querySelector(`toggle-tabs #${dataTabId}`);
      
      // Using tab-selected attribute, open a corresponding tab with the same id
      if (dataTabId && tabSelected) {
        publish(PUB_SUB_EVENTS.switchTab, tabSelected);
      }
      
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener-tabs', ModalOpenerTabs);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class DeferredMediaCustom extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent(focus = true) {
    const self = this;
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      this.querySelector('template').content.querySelectorAll('video, model-viewer, iframe').forEach(function (element) {
        content.append(element.cloneNode(true));
      })

      this.setAttribute('loaded', true);
      content.querySelectorAll('video, model-viewer, iframe').forEach(function (element) {
        self.append(element);
        if (focus) element.focus();
        if (element.nodeName == 'VIDEO' && element.getAttribute('autoplay')) {
          // force autoplay for safari
          element.play();
        }
      });
    }
  }
}

customElements.define('deferred-media-custom', DeferredMediaCustom);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.laptopQuery = window.matchMedia("(min-width: 1024px)").matches;

    if (this.laptopQuery == true) {
      this.verticalSlider = true;
    }
    else {
      this.classList.toggle('vertical-slider');
      this.verticalSlider = false;
    }
    this.resizeHandler();

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  resizeHandler() {
    window.addEventListener('resize', () => {
      let laptopQuery = window.matchMedia("(min-width: 1024px)").matches;
      if (laptopQuery == true) {
        this.verticalSlider = true;
        if (!this.classList.contains('vertical-slider')) {
          this.classList.toggle('vertical-slider');
        }
      }
      else {
        this.classList.toggle('vertical-slider');
        this.verticalSlider = false;
      }
    });
  }

  static get observedAttributes() {
    return ['data-reset'];
  }

  /*
   * Currently used in pdp. The sliders are updated when the variant changes
   * The browser will call this method for each change to the attributes listed in the observedAttributes array.
  */
  attributeChangedCallback(name, oldValue, newValue) {
    //console.log(`Attribute ${name} has changed from ${oldValue} to ${newValue}.`);
    if (oldValue == "false") {
      this.resetPages();
      this.setSlidePosition(0);

      this.setAttribute('data-reset', "false");
    }

  }

  initPages() {
    if (this.verticalSlider == false) {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
    }
    else {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
    }

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();

  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    if (this.verticalSlider == false) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }
    else {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    // When the slider is updated, the "is-active" class is removed and added to the visible "large" slide
    this.sliderItemsToShow.forEach(function (element) {
      element.classList.remove('is-active');
    });
    this.sliderItemsToShow[this.currentPage - 1]?.classList.add('is-active');

    if (this.enableSliderLooping) return;

    if (this.verticalSlider == false) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      }
      else {
        this.nextButton.removeAttribute('disabled');
      }

      if (this.currentPage == this.totalPages) {
        this.nextButton.setAttribute('disabled', 'disabled');
      }
    }
    else {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      if (this.currentPage == this.totalPages) {
        this.nextButton.setAttribute('disabled', 'disabled');
      }
    }

  }

  isSlideVisible(element, offset = 0) {
    if (this.verticalSlider == false) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
    else {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.verticalSlider == false) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    }
    else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    }
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.verticalSlider == false) {
      this.slider.scrollTo({
        left: position,
      });
    }
    else {
      this.slider.scrollTo({
        top: position,
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantOption1Label();
      this.updateVariantOption2Label();
    }
    // console.log(this.currentVariant);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }


  /**
   * When changing the variant, 
   * If there are script tags that match the same color,
   * Select the scripts that contain the html elements with the image to show and add to the slider.
   * The slides already present are hidden.
   * 
   * If the elements have already been added by the scripts, 
   * Only those of the correct color are shown and all the others hidden.
   * Excluding default elements (no color in the image src).
   */
  updateVariantMedia() {
    const parser = new DOMParser();
    // Get the option color number from the "media-gallery" component
    const optionColorPosition = document.querySelector('media-gallery').getAttribute('option-color-position');
    // Save the color of the clicked variant
    const currentColor = this.currentVariant.options[optionColorPosition].toLowerCase();

    const productSliders = document.querySelectorAll('media-gallery slider-component');


    productSliders.forEach( (elementSlider, index, array) => {

      const scripts = elementSlider.querySelectorAll(`ul script[variant-media-color="${currentColor}"]`);
      if (scripts.length > 0) {
        this.updateFromScripts(parser, currentColor, elementSlider, scripts);
      } else {
        this.updateFromHTML(currentColor, elementSlider);
      }

      // At the last iteration change the data attribute of the media-gallery to be able to refresh "media-gallery"
      if (index === array.length - 1) {
        elementSlider.closest('media-gallery').setAttribute("data-reset", "true");
      }
    });
    document.querySelectorAll('product-modal').forEach(function (element) {
      element.setAttribute("data-reset", "true");
      element.setAttribute("variant-media-color", currentColor);
    });

    // UPDATE HIGH VARIANT IMAGES
    this.updateHighMedia(parser, currentColor);
  }

  /**
   * @param {object} parser Convert scripts to html
   * @param {string} currentColor Color of the clicked variant
   * Same functionality as the updateVariantMedia function,
   * But with some additions:
   * - When images are added from scripts, a click event is added
   * - If there are no images corresponding to the color of the clicked variant, I show the default color
   */
  updateHighMedia(parser, currentColor) {
    const self = this;
    let highImageSlider = document.querySelectorAll('.main-product-high slider-component');

    highImageSlider.forEach(function (highElementSlider, index, array) {
      let defaultColor = highElementSlider.getAttribute('variant-default-color');
      let scripts = highElementSlider.querySelectorAll(`ul script[variant-media-color="${currentColor}"]`);

      if (scripts.length != 0) {
        self.updateFromScripts(parser, currentColor, highElementSlider, scripts);
        self.addZoomClick(highElementSlider, currentColor);

      } else {
        let currentColorImages = highElementSlider.querySelectorAll(`ul li[variant-media-color="${currentColor}"]`);

        if (currentColorImages.length != 0) {
          self.updateFromHTML(currentColor, highElementSlider);
        } else {

          // DEFAULT COLOR
          let defaultScriptColor = highElementSlider.querySelectorAll(`ul script[variant-media-color='${defaultColor}']`);
          if (defaultScriptColor.length != 0) {
            self.updateFromScripts(parser, defaultColor, highElementSlider, defaultScriptColor);
            self.addZoomClick(highElementSlider, defaultColor);
          } else {
            self.updateFromHTML(defaultColor, highElementSlider);
          }
        }
      }
    });
  }

  // updateActionMedia(parser, currentColor) {
  //   const self = this;
  //   let actionImageSlider = document.querySelectorAll('.main-product-action swiper-slider');

  //   actionImageSlider.forEach(function (actionElementSlider, index, array) {
  //     let defaultColor = actionElementSlider.getAttribute('variant-default-color');
  //     let scripts = actionElementSlider.querySelectorAll(`ul script[variant-media-color="${currentColor}"]`);

  //     if (scripts.length != 0) {
  //       self.updateFromScripts(parser, currentColor, actionElementSlider, scripts);
  //       self.addZoomClick(actionElementSlider, currentColor);
  //       // click event for every new slide because the slider is Swiper
  //       actionElementSlider.querySelectorAll(`ul li[variant-media-color="${currentColor}"]`).forEach(function (element) {
  //         let buttonToTrigger = element.querySelector('modal-opener button');
  //         element.addEventListener('click', function () {
  //           buttonToTrigger.click();
  //         });
  //       });

  //     } else {
  //       let currentColorImages = actionElementSlider.querySelectorAll(`ul li[variant-media-color="${currentColor}"]`);

  //       if (currentColorImages.length != 0) {
  //         self.updateFromHTML(currentColor, actionElementSlider);
  //       } else {
  //         // DEFAULT COLOR
  //         let defaultScriptColor = actionElementSlider.querySelectorAll(`ul script[variant-media-color='${defaultColor}']`);
  //         if (defaultScriptColor.length != 0) {
  //           self.updateFromScripts(parser, defaultColor, actionElementSlider, defaultScriptColor);
  //           self.addZoomClick(actionElementSlider, defaultColor);
  //           // click event for every new slide because the slider is Swiper
  //           actionElementSlider.querySelectorAll(`ul li[variant-media-color='${defaultColor}']`).forEach(function (element) {
  //             let buttonToTrigger = element.querySelector('modal-opener button');
  //             element.addEventListener('click', function () {
  //               buttonToTrigger.click();
  //             });
  //           });
  //         } else {
  //           self.updateFromHTML(defaultColor, actionElementSlider);
  //         }
  //       }
  //     }
  //   });
  // }

  updateFromScripts(parser, currentColor, elementSlider, scripts) {

    scripts.forEach(function (elementScript, index, array) {

      let imagesToHide = elementSlider.querySelectorAll(`ul li`);
      imagesToHide.forEach(function (imgToHide) {
        if (imgToHide.getAttribute('variant-media-color') != currentColor) {
          imgToHide.style.display = "none";
        }
      })

      let htmlDoc = parser.parseFromString(elementScript.innerHTML, 'text/html');
      htmlDoc.querySelector('li').classList.add('js-media-gallery-update');
      elementScript.closest('ul').appendChild(htmlDoc.querySelector('li'));

      elementScript.remove();

      // At the last iteration change the data attribute of the slider to be able to refresh "slider-component"
      if (index === array.length - 1) {
        elementSlider.setAttribute("data-reset", "true");
      }
    })
  }

  updateFromHTML(currentColor, elementSlider) {
    let imagesAlreadyAdded = elementSlider.querySelectorAll(`ul li:not(.product__media-item--default, .thumbnail-list__item--default)`);
    imagesAlreadyAdded.forEach(function (imgAdded, index, array) {
      if (imgAdded.getAttribute('variant-media-color') != currentColor) {
        imgAdded.classList.remove('js-slide-visible');
        imgAdded.style.display = "none";
      } else {
        imgAdded.classList.add('js-slide-visible');
        imgAdded.style.display = "flex";
      }

      // At the last iteration change the data attribute of the slider to be able to refresh "slider-component"
      if (index === array.length - 1) {
        elementSlider.setAttribute("data-reset", "true");
      }
    });
  }

  addZoomClick(element, color) {
    //console.log("click");
    element.querySelectorAll(`ul li[variant-media-color='${color}']`).forEach(function (element) {
      //console.log(element);
      let buttonToTrigger = element.querySelector('modal-opener button');
      //console.log(buttonToTrigger);
      let zoomTrigger = element.querySelector('.tw-pdp-zoom-trigger');
      zoomTrigger.addEventListener('click', function () {
        buttonToTrigger.click();
      });
    });
  }

  updateMedia() {
    this.updateVariantMedia();
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantOption1Label() {
    let currentVariantColor = this.querySelector('.form__label--option1');
    currentVariantColor.innerHTML = this.currentVariant.option1;
  }

  updateVariantOption2Label() {
    let currentVariantSize = this.querySelector('.form__label--option2');
    currentVariantSize.innerHTML = this.currentVariant.option2;
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      //show notify_me
      if (text === window.variantStrings.soldOut) {
        addButton.setAttribute('hidden', 'hidden');
        productForm.querySelector(".notify_button").classList.remove("tw-hidden");
      }
    } else {
      if (!productForm.querySelector(".notify_button").classList.contains("tw-hidden")) {
        addButton.removeAttribute('hidden', 'hidden');
        productForm.querySelector(".notify_button").classList.add("tw-hidden");
      }
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // When clicked a label in the custom element, the js-first-load class is removed
    //this.querySelectorAll('fieldset label').forEach((el) => el.addEventListener('click', this.firstClick));
    this.firstClick();
  }

  firstClick() {
    this.hidePreselectedSize();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled', 'tw-pdp-notify');
      } else {
        input.classList.add('disabled', 'tw-pdp-notify');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  /**
   * Eseguito solo una volta se è presente la classe 'js-first-load'.
   * Per l'arrivo in PDP la prima volta in modo da nascondere la taglia preselezionata.
   * Viene trovata subito la currentVariant nel caso l'utente clicca la taglia preselezionata
   * 
   * Viene aggiornato il badge SALE se una variante colore è in saldo.
   */
  hidePreselectedSize() {
    const self = this;
    const productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
    if (productInfo.classList.contains('js-first-load')) {

      this.updateOptions();
      this.updateMasterId();
      this.querySelectorAll('fieldset label').forEach(function (el) {
        el.addEventListener('click', function () {
          productInfo.classList.remove('js-first-load');

          if (!productInfo.classList.contains('js-first-load')) {
            productInfo.querySelector('.product__price .price__container').style.opacity = 0.2;
          }

          let badgeOnSale = document.querySelector('.product__media-wrapper .tw-card__badge__product #badge-sale');
          let dataVariantSale = el.getAttribute('data-variant-on-sale');
          if (badgeOnSale) {
            if (dataVariantSale == "true") {
              badgeOnSale.style.display = "block";
            }
            else {
              badgeOnSale.style.display = "none";
            }
          }
        })
      })
      this.querySelectorAll('fieldset label.label--image-product').forEach(function (el) {
        el.addEventListener('click', function () {
          productInfo.classList.remove('js-first-load');

          if (!productInfo.classList.contains('js-first-load')) {
            productInfo.querySelector('.product__price .price__container').style.opacity = 0.2;
          }

          let badgeNew = document.querySelector('#badge-new');
          let dataVariantNew = el.getAttribute('data-variant-new');
          if (badgeNew) {
            if (dataVariantNew == "true") {
              badgeNew.style.display = "block";
            }
            else {
              badgeNew.style.display = "none";
            }
          }
        })
      })
    }
  }
  showNewLabel() {
    this.querySelectorAll('fieldset label.label--image-product').forEach(function (el) {
      console.log(el);
      let badgeNew = document.querySelector('#badge-new');
      let dataVariantNew = el.getAttribute('data-variant-new');
      console.log(dataVariantNew);
      if (badgeNew) {
        if (dataVariantNew == "true") {
          badgeNew.style.display = "block";
        }
        else {
          badgeNew.style.display = "none";
        }
      }
    })
  }
}

customElements.define('variant-radios', VariantRadios);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  get products() {
    return JSON.parse(this.dataset.products);
  }

  get limit() {
    return this.dataset.limit;
  }



  connectedCallback() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.render();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  async render() {
    const builder = new SearchRequestBuilder()
        .withProducts(this.products)
        .withAttributes(["handle"])
        .withLimit(this.limit);

    const searchResponse = await fetch(builder.complementary());
    const searchResponseJSON = await searchResponse.json();

    const items = searchResponseJSON.product_data

    const sectionResponse = await fetch(SearchPage.getSectionRenderUrl(items, 'recommended'));
    const sectionResponseText = await sectionResponse.text();

    const html = new DOMParser().parseFromString(sectionResponseText, "text/html");
    this.querySelector('[data-swiper-wrapper]').innerHTML = html.querySelector('[result]').innerHTML;

    this.handleCardsSize();
    window.addEventListener('resize', () => this.handleCardsSize());
  }

  handleCardsSize() {
    const swiperWrapper = this.querySelector('[data-swiper-wrapper]');
    if (!swiperWrapper) return;

    swiperWrapper.style.height = null;
    const slideHeights = Array.from(this.querySelectorAll('.swiper-slide')).map(slide => slide.offsetHeight);
    const maxHeight = Math.max(...slideHeights);
    
    swiperWrapper.style.height = `${maxHeight}px`;

  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.initialText = this.querySelector('.js-read-more--initial-text');
    this.toggleButton = this.querySelector('.trigger');
    this.contentElement = this.querySelector('.js-read-more .js-read-more--text');
    this.blurElement = this.querySelector('.js-read-more--blur');

    this.escapeHtml = this.getAttribute('escape-html') || 'true';

    this.longContent = this.escapeHtml == 'true' ? this.contentElement.textContent : this.contentElement.innerHTML;

    // If set false in the html, the read less is disabled
    this.enableReadLess = this.getAttribute('enable-read-less');

    // In the html set a number of characters to create the substring
    this.charactersSubstring = this.getAttribute('data-truncate');
    if (!this.charactersSubstring) {
      this.charactersSubstring = 90;
    }
  }

  cutText() {
    this.shortContent = `${this.longContent.substring(0, this.charactersSubstring)}...`;

    this.contentElement.innerHTML = this.shortContent;
    //this.contentElement.appendChild(this.toggleButton);
    this.setAttribute('data-content', 'short');
    this.classList.remove('tw-opacity-0');
  }

  connectedCallback() {
    if (this.longContent.length < this.charactersSubstring) {
      this.textShortEnough();
      return;
    }

    this.listener();
    this.cutText();
  }

  listener() {
    this.toggleButton.addEventListener("click", () => {
      this.toggleText();
    });
  }

  toggleText() {
    // if (this.classList.contains('tw-initial-read-more')) {
    //   this.classList.remove('tw-initial-read-more');
    // }
    if (this.dataset.content == 'long') {
      this.contentElement.innerHTML = this.shortContent;
      if (this.blurElement) {
        this.blurElement.classList.remove('tw-hidden');
      }
      //this.contentElement.appendChild(this.toggleButton);
      this.toggleButton.innerText = this.toggleButton.getAttribute('text-more');
      this.setAttribute('data-content', 'short');
    }
    else {
      this.contentElement.innerHTML = this.longContent;
      if (this.enableReadLess != "false") {
        
        if (this.blurElement) {
          this.blurElement.classList.add('tw-hidden');
        }

        //this.contentElement.appendChild(this.toggleButton);
        this.toggleButton.innerText = this.toggleButton.getAttribute('text-less');
      }
      this.setAttribute('data-content', 'long');
    }
  }

  textShortEnough() {
    this.classList.remove('tw-opacity-0');

    if (this.blurElement) {
      this.blurElement.classList.add('tw-hidden');
    }
    
    this.toggleButton.classList.add('tw-hidden');
  }

}

customElements.define('read-more', ReadMore);

/**
 * Derived from ReadMore, it is used for parts where the read more must only be mobile
 */
class ReadMoreMobile extends ReadMore {
  constructor() {
    super();

    this.mobile = window.matchMedia("(max-width: 767px)").matches;
    this.resizeHandler();
  }

  connectedCallback() {
    if (this.mobile == true) {
      this.dataset.content == 'short'
      this.cutText();
    } else {
      this.toggleButton.classList.add('tw-hidden');
      this.classList.remove('tw-opacity-0');
    }
  }

  resizeHandler() {
    window.addEventListener('resize', () => {
      let mobile = window.matchMedia("(max-width: 767px)").matches;
      if (mobile == false && this.dataset.content == 'short') {
        this.contentElement.innerHTML = this.longContent;
        this.setAttribute('data-content', 'long');
      }
      if ((mobile == true && this.classList.contains('tw-initial-read-more'))) {
        this.classList.remove('tw-initial-read-more');
      }
    });
  }

}

customElements.define('read-more-mobile', ReadMoreMobile);

class AdaptiveSelect extends HTMLElement {
  constructor() {
    super();
    this.mainSelect = this.querySelector(".select__select")
    this.widthSelect = this.querySelector("#width_tmp_select");
    this.optionWidth = this.querySelector("#width_tmp_option");
  }

  connectedCallback() {
    this.startWidth();
    this.bindEvents();
  }

  setSelectWidth() {
    this.optionWidth.innerHTML = this.mainSelect.options[this.mainSelect.selectedIndex].innerText.trim();
    this.mainSelect.style.width = this.widthSelect.offsetWidth + "px";
  }

  startWidth() {
    this.setSelectWidth();
    this.mainSelect.style.display = "block";
  }

  bindEvents() {
    this.mainSelect.addEventListener("change", () => {
      this.setSelectWidth();
    })
  }
}

customElements.define('adaptive-select', AdaptiveSelect);

class MorePaymentOptions extends HTMLElement {
  constructor() {
    super();
    this.morePaymentOptionBtn = this.querySelector('details');
    this.lessPaymentOptionBtn = this.querySelector('details .less-payment-option');
    // this.cartPaymentsWrapper = this.cartPaymentsContainer.firstChild;
  }

  connectedCallback() {
    this.eventListener();
    this.cartPaymentObserver();
  }

  cartPaymentObserver() {
    this.cartPaymentsContainer = this.querySelector(".dynamic-checkout__content");

    // Verifica che l'elemento esista prima di creare l'osservatore
    if (this.cartPaymentsContainer) {
      // Definisci la funzione di callback per l'osservatore
      const mutationCallback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // Il contenuto dell'elemento è cambiato
            this.cartPaymentWrapper = this.cartPaymentsContainer.querySelectorAll('.shopify-cleanslate')[1];
            this.cartPaymentElement = this.cartPaymentWrapper?.querySelectorAll('ul li');
            if (this.cartPaymentElement?.length >= 1) {
              this.morePaymentOptionBtn.style.display = "block";
              publish(PUB_SUB_EVENTS.loadedPayments, '');
              break;
            } else {
              this.morePaymentOptionBtn.style.display = "none";
            }
          }
        }
      };
      const observer = new MutationObserver(mutationCallback);
      const observerOptions = {
        childList: true,
        subtree: true
      };
      observer.observe(this.cartPaymentsContainer, observerOptions);
    }
  }


  eventListener() {
    this.resize();
    if (window.innerWidth > 1024) {
      this.morePaymentOptionBtn.setAttribute('open', '');
    }
    // Add the resize event listener to the window object
    this.lessPaymentOptionBtn.addEventListener('click', () => {
      this.morePaymentOptionBtn.removeAttribute('open');
    })
  }
  resize() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        this.morePaymentOptionBtn.setAttribute('open', '');
      } else {
        // Optionally, close the button on smaller screens (if desired)
        this.morePaymentOptionBtn.removeAttribute('open');
      }
    })
  }
}

customElements.define('more-payment-options', MorePaymentOptions)

class CustomPlusAccordion extends HTMLElement {
  constructor() {
    super();
    this.promoCodeElement = this.querySelector('.promoCode');
  }

  connectedCallback() {
    this.addEventListeners();
  }


  addEventListeners() {

    this.promoCodeElement.addEventListener('click', this.toggleClass.bind(this));
  }

  toggleClass() {
    const spanElement = this.promoCodeElement.querySelector('span');
    if (spanElement) {
      spanElement.classList.toggle('opened');
    }
  }
}

customElements.define('custom-plus-accordion', CustomPlusAccordion);

class CustomDetailsElement extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
  }

  connectedCallback() {
    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    this.details.style['overflow'] = 'hidden';

    if (this.details.open) {
      event.preventDefault();
      this.details.open = false;
      this.details.style['overflow'] = 'visible';
      this.details.style['max-height'] = '5.4rem';
    } else {
      this.details.style['max-height'] = '70rem';
    }
  }
}

customElements.define('custom-details', CustomDetailsElement);

class AnchorScroller extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('.js-scroller-element');

    if (this.scroller) {
      this.scroller.addEventListener("click", this.handleClick.bind(this));
    } else {
      console.warn("AnchorScroller: No `.js-scroller-element` element found inside.");
    }
  }

  handleClick(event) {
    event.preventDefault();

    const targetId = this.scroller.dataset.scrollToElement;
    if (!targetId) {
      console.warn("AnchorScroller: No `scroll-to-element` attribute specified.");
      return;
    }
    const targetElement = document.querySelector(`#${targetId}`);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn(`AnchorScroller: No element found with ID "${targetId}".`);
    }
  }
}

customElements.define('anchor-scroller', AnchorScroller);

(function initNewsletterPopup() {
  // Set the initial interval for displaying the newsletter popup (in milliseconds)
  const interval = 60000;

  // Retrieve the existing end time from localStorage, or reset it if not found
  const storedEndTime = localStorage.getItem('endTime');
  let endTime = storedEndTime ? parseInt(storedEndTime) : +new Date + interval;

  // Function to reset the end time for the next popup display
  // function resetEndTime() {
  //   endTime = +new Date + interval;
  //   localStorage.setItem('endTime', endTime.toString());
  // }

  // Main execution loop (setInterval)
  let intervalId;

  intervalId = setInterval(function () {
    const remainingTime = endTime - new Date();
    // ... rest of your code
    if (remainingTime <= 0) {
      publish(PUB_SUB_EVENTS.newsletterTimerEnded);
      clearInterval(intervalId); // Use the stored interval ID
    }
  }, 100);
  // Check every 100 milliseconds (adjust for desired precision)
})()


